export default __webpack_public_path__ + "static/media/sofiapro-light.7978d11b.otf";